var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.tamanho,"height":_vm.tamanho,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},_vm._l((_vm.paths),function(d,index){return _c('path',{key:index,attrs:{"d":d}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }